import React from 'react'
import Typography from "@mui/material/Typography";
import {useMediaQuery} from "react-responsive";
import {mediaQueryForMobile} from "../HomePage/HomePage";
import {DeskingTableRowCell} from "./DeskingTableRowCell";
import QuoteHelper from "../../utils/QuoteHelper";

export const DeskingTableRow = ( { term, quotes, lenders, dealId, dealState, onSave, sortBy } ) => {
    const isTabletOrMobile = useMediaQuery({ query: mediaQueryForMobile })

    const isSortByLender = sortBy === 'Lender'
    const isSortByBestPayment = sortBy === 'BestPayment'

    const isCashDeal = dealState.is_purchase && dealState.is_one_pay

    return (
        <tr>
            <td className={'term'}>
                <Typography
                    fontWeight={400}
                    fontSize={20}
                    variant="div"
                    gutterBottom>
                    {isCashDeal ? '0' : term}
                </Typography>
            </td>
            {
                isSortByBestPayment &&
                quotes.map((quote, index) => {
                    return <DeskingTableRowCell
                        isPurchase={dealState.is_purchase}
                        dealId={dealId}
                        quote={quote}
                        key={`${quote.lender_name}-${term}`}
                        onSave={onSave}
                        lender={quote.lender_name}
                        term={term}
                    />
                })
            }
            {
                isSortByLender &&
                lenders.map((lender, index) => {
                    const quote = quotes[lender]

                    return <DeskingTableRowCell
                        isPurchase={dealState.is_purchase}
                        dealId={dealId}
                        quote={quote}
                        key={`${lender}-${term}`}
                        onSave={onSave}
                        lender={lender}
                        term={term}
                    />
                })
            }
        </tr>
    )
}